__turbopack_context__.v({
  "mainImage": "dibRqW_mainImage",
  "paraMarginBottom": "dibRqW_paraMarginBottom",
  "sliderContent": "dibRqW_sliderContent",
  "sliderOverlay": "dibRqW_sliderOverlay",
  "slidesInfo": "dibRqW_slidesInfo",
  "titleMarginBottom": "dibRqW_titleMarginBottom",
  "verticalLine": "dibRqW_verticalLine",
});
